/* eslint-disable class-methods-use-this */
import WsFirestoreCollection from "./WsFirestoreCollection";

export default class WsFirestore {
  collection(col) {
    return new WsFirestoreCollection(col);
  }
}
